import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { Order, OrderCount } from '../../types/Order';
import { DataFetchError } from '../../utils/ErrorClass';

export const useOrder = () => {
  const [orders, setOrders] = useState<OrderCount[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const itemsPerPage = 50;

  const fetchOrders = useCallback(async () => {

    try {
      // データを取得
      const { data, error: functError } = await supabase
        .rpc('get_order_summaries', {
          page_number: page,
          page_size: itemsPerPage,
          search_query: searchQuery
        });

      if (functError) {
        throw new DataFetchError("データの取得失敗: " + functError.message);
      }

      setOrders(data as OrderCount[]);
      setTotalPages(Math.ceil((data[0]?.受注番号合計 || 0) / itemsPerPage)); // totalPagesを計算
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    }
  }, [page, searchQuery]);

  const fetchOrderByNumber = useCallback(async (orderNumber: number) => {
    try {
      const { data, error } = await supabase
        .from('order')
        .select('*')
        .eq('受注番号', orderNumber);

      if (error) {
        throw new DataFetchError("データの取得失敗: " + error.message);
      }

      return data as Order[];
    } catch (err) {
      console.error(err);
      return [];
    }
  }, []);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  return { orders, fetchOrders, setPage, page, totalPages, fetchOrderByNumber, setSearchQuery, error };
};
